export const STRIPE_LINKS = {
  AU: 'https://pay.businesskitz.com.au',
  SANDBOX: 'https://buy.stripe.com',
};

export const PRODUCT_PLANS_LINKS = {
  DEV: {
    BUSINESS_STARTER: `${STRIPE_LINKS.SANDBOX}/test_cNi6oI1jN7AI6Ir2EXdZ600`,
    BUSINESS_ESSENTIALS: `${STRIPE_LINKS.SANDBOX}/test_6oU3cwcYRejt6n4aOs4AU00`,
    BUSINESS_ESSENTIALS_ESSA: `${STRIPE_LINKS.SANDBOX}/test_14A14o8Mf08g9UDa7pdZ60o`,
    BUSINESS_GROWTH: `${STRIPE_LINKS.SANDBOX}/test_dRmdRa7Ex8Z9aDk4q44AU01`,
    BUSINESS_STARTER_ANNUAL: `${STRIPE_LINKS.SANDBOX}/test_8x2dRafaDbQY5EngvNdZ601`,
    BUSINESS_GROWTH_ESSA: `${STRIPE_LINKS.SANDBOX}/test_9B6aEYaUn4oweaTenFdZ60p`,
    BUSINESS_ESSENTIALS_ANNUAL: `${STRIPE_LINKS.SANDBOX}/test_00w28s3ohdfp26O4q44AU02`,
    BUSINESS_GROWTH_ANNUAL: `${STRIPE_LINKS.SANDBOX}/test_dRmaEYbUNfnx8vcbSw4AU03`,
    APA_DISCOUNTED_ESSENTIALS: `${STRIPE_LINKS.SANDBOX}/test_4gMfZi8IB6R14eW5u84AU04`,
    APA_FREE_ESSENTIALS: `${STRIPE_LINKS.SANDBOX}/test_4gMfZi8IB6R14eW5u84AU04`,
    APA_FREE_GROWTH: `${STRIPE_LINKS.SANDBOX}/test_3cI4gA7Exejt26ObSw4AU05`,
    ESIGN_ONLY: `${STRIPE_LINKS.SANDBOX}/test_4gM5kEgeHbQY9UDfrJdZ60k`,
    ESIGN_ONLY_ESSA: `${STRIPE_LINKS.SANDBOX}/test_28EfZie6z5sA5En6VddZ60q`,
    ESIGN_ONLY_ANNUAL: `${STRIPE_LINKS.SANDBOX}/test_4gMfZi4vZaMUd6P1ATdZ60l`,
  },
  TEST: {
    BUSINESS_STARTER: `${STRIPE_LINKS.SANDBOX}/test_cNi6oI1jN7AI6Ir2EXdZ600`,
    BUSINESS_ESSENTIALS: `${STRIPE_LINKS.SANDBOX}/test_7sY6oI4vZ9IQgj193ldZ60g`,
    BUSINESS_ESSENTIALS_ESSA: `${STRIPE_LINKS.SANDBOX}/test_14A14o8Mf08g9UDa7pdZ60o`,
    BUSINESS_GROWTH: `${STRIPE_LINKS.SANDBOX}/test_3cI9AU7Ib9IQ0k393ldZ60f`,
    BUSINESS_STARTER_ANNUAL: `${STRIPE_LINKS.SANDBOX}/test_8x2dRafaDbQY5EngvNdZ601`,
    BUSINESS_GROWTH_ESSA: `${STRIPE_LINKS.SANDBOX}/test_9B6aEYaUn4oweaTenFdZ60p`,
    BUSINESS_ESSENTIALS_ANNUAL: `${STRIPE_LINKS.SANDBOX}/test_aFadRa8Mf08g6Ir4N5dZ60e`,
    BUSINESS_GROWTH_ANNUAL: `${STRIPE_LINKS.SANDBOX}/test_8x2aEY7Ib2go5En0wPdZ60d`,
    APA_DISCOUNTED_ESSENTIALS: `${STRIPE_LINKS.SANDBOX}/test_00wcN66E708g5En93ldZ60h`,
    APA_FREE_ESSENTIALS: `${STRIPE_LINKS.SANDBOX}/test_00w9AUe6zf3ac2L4N5dZ60j`,
    APA_FREE_GROWTH: `${STRIPE_LINKS.SANDBOX}/test_3cI28s9Qj5sA4AjenFdZ60i`,
    ESIGN_ONLY: `${STRIPE_LINKS.SANDBOX}/test_4gM5kEgeHbQY9UDfrJdZ60k`,
    ESIGN_ONLY_ESSA: `${STRIPE_LINKS.SANDBOX}/test_28EfZie6z5sA5En6VddZ60q`,
    ESIGN_ONLY_ANNUAL: `${STRIPE_LINKS.SANDBOX}/test_4gMfZi4vZaMUd6P1ATdZ60l`,
  },
  PROD: {
    BUSINESS_STARTER: `${STRIPE_LINKS.AU}/b/3cI3cwbPC4eUfmafEhawo0k`,
    BUSINESS_ESSENTIALS: `${STRIPE_LINKS.AU}/b/3cI7sMf1O3aQfmagIlawo0u`,
    BUSINESS_ESSENTIALS_ESSA: `${STRIPE_LINKS.AU}/b/fZueVe3j68va1vkajXawo0E`,
    BUSINESS_GROWTH: `${STRIPE_LINKS.AU}/b/28E4gAdXK4eU0rgcs5awo0t`,
    BUSINESS_GROWTH_ESSA: `${STRIPE_LINKS.AU}/b/bJeaEY2f2bHmc9YajXawo0F`,
    BUSINESS_STARTER_ANNUAL: `${STRIPE_LINKS.AU}/b/14A14of1O26Ma1Qbo1awo0p`,
    BUSINESS_ESSENTIALS_ANNUAL: `${STRIPE_LINKS.AU}/b/8x2fZidXKaDiei60Jnawo0w`,
    BUSINESS_GROWTH_ANNUAL: `${STRIPE_LINKS.AU}/b/14AcN6dXK9zegqecs5awo0v`,
    APA_DISCOUNTED_ESSENTIALS: `${STRIPE_LINKS.AU}/b/bJe00k3j6dPub5U2Rvawo0y`,
    APA_FREE_ESSENTIALS: `${STRIPE_LINKS.AU}/b/bJe00k3j6dPub5U2Rvawo0y`,
    APA_FREE_GROWTH: `${STRIPE_LINKS.AU}/b/4gM3cw5reeTyb5U9fTawo0x`,
    ESIGN_ONLY: `${STRIPE_LINKS.AU}/b/8x28wQ5re26M0rg8bPawo0B`,
    ESIGN_ONLY_ESSA: `${STRIPE_LINKS.AU}/b/4gMdRa7zm4eU5LA63Hawo0D`,
    ESIGN_ONLY_ANNUAL: `${STRIPE_LINKS.AU}/b/4gM7sMbPCh1G3Ds2Rvawo0C`,
  },
};
